import { Modal, Typography, type TypographyElement } from "@drone-js/core";
import type { useDisclosure } from "apps/commons/hooks/useDisclosure";
import { type FunctionComponent, useRef } from "react";
import Markdown from "react-markdown";
import { useStaticDataAtomValue } from "../staticDataAtom";

export const TermsModal: FunctionComponent<ReturnType<typeof useDisclosure>> = ({ open, onClose }) => {
    const {
        contractDetail: { termsAndConditionsText },
        cmsData: {
            publish: { termsModal, close, download },
        },
    } = useStaticDataAtomValue();
    const termsElement = useRef<TypographyElement>(null);

    const handleDownload = () => {
        let cloned = termsElement.current.cloneNode(true);
        document.body.appendChild(cloned);
        // @ts-ignore classList actually exist
        cloned.classList.add("printable");
        window.print();
        document.body.removeChild(cloned);
    };

    return (
        <Modal
            size="m"
            title={termsModal}
            visible={open}
            onClose={onClose}
            actions={[
                {
                    label: close,
                    variant: "label",
                    hierarchy: "primary",
                    onClick: onClose,
                    actionType: "button",
                },
                {
                    label: download,
                    variant: "label",
                    hierarchy: "secondary",
                    onClick: handleDownload,
                    actionType: "button",
                },
            ]}
        >
            <Typography variant="body-s" ref={termsElement}>
                <Markdown>{termsAndConditionsText}</Markdown>
            </Typography>
        </Modal>
    );
};
